import { createFileRoute } from '@tanstack/react-router';
import { SharedDocumentPage } from '@/features/shared-document/SharedDocumentPage';

export const Route = createFileRoute('/shared-document/$token')({
  // The recipient's emailed link carries their own address as ?email=... so the download can be
  // attributed back to them. Optional: links opened without it still work (unattributed download).
  validateSearch: (search: Record<string, unknown>): { email?: string } => ({
    email: typeof search.email === 'string' ? search.email : undefined,
  }),
  component: SharedDocumentRoute,
});

function SharedDocumentRoute() {
  const { token } = Route.useParams();
  const { email } = Route.useSearch();
  return <SharedDocumentPage token={token} email={email} />;
}
